var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTriHarder2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "4 91 242 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m7.01 105.1v6.26h5.48v32.78h6.37v-32.78h6.56v-6.26h-19.17z",
    fill: "#FB6210"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m28.61 105.1h10.46c7 0 8.94 2.94 8.94 9.37v2.4c0 4.55-1.3 6.5-3.3 7.6 2.45 1.2 3.3 2.9 3.3 8.4v6.3c0 2.2 0.05 3.85 0.8 4.95h-6.5c-0.35-1.05-0.6-2.1-0.6-4.45v-7.1c0-3.7-0.8-4.85-3.75-4.85h-2.3v16.4h-7.05v-39.02zm9.5 16.77c2.6 0 3.55-1.3 3.55-4.65v-1.85c0-3-0.85-4.25-3.45-4.25h-2.75v10.75h2.65z",
    fill: "#FB6210"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m52.46 105.1h7v39.02h-7v-39.02z",
    fill: "#FB6210"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m63.66 123.4h11.5v4.5h-11.5v-4.5z",
    fill: "#002349"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m79.81 105.1h4.7v16.57h8.8v-16.57h4.7v39.02h-4.7v-18.25h-8.8v18.25h-4.7v-39.02z",
    fill: "#002349"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m116.1 135.6h-9.25l-1.6 8.55h-3.8l6.75-39.02h6.65l7.1 39.02h-4.25l-1.6-8.55zm-4.7-25.57-3.9 21.67h7.95l-4.05-21.67z",
    fill: "#002349"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m124.9 105.1h8.85c6.65 0 8.4 3.95 8.4 9.8v1.7c0 5.05-1.55 7.55-4.45 8.6 3.05 1.05 4.3 3.25 4.3 8.7v6c0 1.8 0.05 3.3 0.7 4.25h-4.9c-0.4-1-0.5-2.05-0.5-4.2v-6.65c0-4.6-1.15-6.4-5.1-6.4h-2.85v17.25h-4.45v-39.05zm8.1 17.6c3.6 0 4.8-2.1 4.8-6.4v-1.3c0-3.85-1.2-5.8-4.9-5.8h-3.55v13.5h3.65z",
    fill: "#002349"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m146.8 105.1h9.35c7.25 0 8.8 4.25 8.8 10.7v16.95c0 6.7-1.6 11.37-9.05 11.37h-9.1v-39.02zm8.8 34.82c4.6 0 4.85-3.45 4.85-7.95v-15.8c0-4.5-0.7-6.95-5.05-6.95h-4.25v30.7h4.45z",
    fill: "#002349"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m169.6 105.1h16.05v4.2h-11.5v12.57h9.25v4.1h-9.25v14h11.55v4.15h-16.1v-39.02z",
    fill: "#002349"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "m189.3 105.1h8.85c6.65 0 8.4 3.65 8.4 9.5v2c0 5.05-1.55 7.25-4.1 8.3 2.9 1.05 3.95 3.1 3.95 8.8v6.2c0 1.8 0.05 3.3 0.7 4.25h-4.55c-0.4-1-0.5-2.05-0.5-4.2v-6.65c0-4.6-1.15-6.4-5.1-6.4h-3.2v17.25h-4.45v-39.05zm8.1 17.6c3.6 0 4.8-2.1 4.8-6.4v-1.3c0-3.85-1.2-5.8-4.9-5.8h-3.55v13.5h3.65z",
    fill: "#002349"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "m208.6 93.64h14.15l21.04 31.1-21.29 30.75h-14.15l21.8-30.75-21.55-31.1z",
    fill: "#FB6210"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTriHarder2);
export default __webpack_public_path__ + "static/media/tri-harder-2.914015cb7328ffe32fc7e6a1f7a9f5f1.svg";
export { ForwardRef as ReactComponent };